import { SpinnerGapIcon, WarningIcon } from '@phosphor-icons/react'

const LoadingScreen = ({ error, onRetry }) => {
  if (error) return (
    <div className='LoadingScreen'>
      <WarningIcon size={32} />
      <p className='medium'>{error}</p>
      {onRetry && <button className='button medium' onClick={onRetry}>Try again</button>}
    </div>
  );
  return (
    <div className='LoadingScreen'>
      <SpinnerGapIcon size={32} className='spin' />
    </div>
  );
};

export default LoadingScreen
